import { Add, Pencil } from "@components/icons"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import { body14Styles } from "@constants/typography"
import React from "react"
import styled from "styled-components"

const Button = styled.button`
  display: flex;
  width: 100%;
  height: 56px;
  padding: 0 20px;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  outline: none;
  border: none;
  background: none;
  border-bottom: solid 1px ${colors.dividerLineGray};
  cursor: pointer;

  @media ${breakpoints.tablet} {
    padding: 0 32px;
  }

  @media ${breakpoints.laptop} {
    display: none;
  }
`

const TextWrapper = styled.div`
  display: flex;
`

const TextBlack = styled.div`
  ${body14Styles}
  margin-right: 6px;
`

const Text = styled.div`
  ${body14Styles}
  color: ${colors.mediumDarkGray};
`

const PlusIcon = styled.div`
  transform: translateX(6px);
  width: 28px;
  height: 28px;
`

const PencilIcon = styled.div`
  transform: translateX(4px);
  width: 18px;
  height: 18px;
`

interface DiscountButtonProps {
  discount?: string
  openAddDiscount: () => void
  openEditDiscount: () => void
}

const DiscountButton: React.FC<DiscountButtonProps> = ({
  discount,
  openAddDiscount,
  openEditDiscount,
}) => {
  return discount ? (
    <Button
      onClick={(e) => {
        e.stopPropagation()
        openEditDiscount()
      }}
    >
      <TextWrapper>
        <TextBlack>Discount Code:</TextBlack>
        <Text>{discount}</Text>
      </TextWrapper>
      <PencilIcon>
        <Pencil />
      </PencilIcon>
    </Button>
  ) : (
    <Button
      onClick={(e) => {
        e.stopPropagation()
        openAddDiscount()
      }}
    >
      <Text>Add a discount code</Text>
      <PlusIcon>
        <Add strokeColor={colors.mediumDarkGray} />
      </PlusIcon>
    </Button>
  )
}

export default DiscountButton
